import { usePriceIntent } from '@/features/priceCalculator/usePriceIntent'
import { Features } from '@/utils/Features'
import { FetchInsurance } from './FetchInsurance'

export function FetchInsuranceContainer() {
  const { priceIntent } = usePriceIntent()

  if (!priceIntent) {
    return null
  }

  if (!Features.enabled('INSURELY')) return null
  if (!priceIntent.externalInsurer) return null
  if (!priceIntent.insurely) return null

  return (
    <FetchInsurance
      priceIntentId={priceIntent.id}
      externalInsurer={priceIntent.externalInsurer}
      insurely={priceIntent.insurely}
      productName={priceIntent.product.displayNameFull}
      companyName={priceIntent.externalInsurer.displayName}
    />
  )
}
